'use strict';

module.exports = require('./_google');
